import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { ReferralDetails } from 'frontend/types/referral';

interface ReferralDetailsState {
  referralDetailsData: ReferralDetails | null;
}

const referralDetails: Module<ReferralDetailsState, RootState> = {
  namespaced: true,
  state: {
    referralDetailsData: null,
  },
  mutations: {
    setValue(state: ReferralDetailsState, value: ReferralDetails): void {
      state.referralDetailsData = value;
    },
  },
  actions: {},
};

export default referralDetails;
